module.exports = __webpack_public_path__ + "static/media/decoration.fba5de97.svg";